import React, { forwardRef } from "react";

import * as S from "./style";

interface HTMLRenderProps {
  children: string;
  maxHeight?: string;
}

const HTMLRender = forwardRef<HTMLDivElement, HTMLRenderProps>(
  ({ children = "", maxHeight = "" }, ref) => {
    const message = children
      // remove unnecessary line breaks
      .replace(new RegExp("<p>&nbsp;</p>", "g"), "")
      .replace(new RegExp("<br><br>", "g"), "<br>")
      .replace(new RegExp("<p><br>", "g"), "<p>")

      // make images clickable to open high-res version
      .replace(new RegExp('<img src="(.*?)"', "g"), (_match, p1) => {
        const highResUrl = p1.includes("/w/500/")
          ? p1.replace("/w/500/", "/w/1200/")
          : p1;
        return `<img src="${p1}" onclick="window.open('${highResUrl}', '_blank')"`;
      })

      // open links on new tab
      .replace(new RegExp('target="_self"', "g"), 'target="_blank"')
      .replace(new RegExp("<a(?![^>]*target=)", "g"), '<a target="_blank"');

    return (
      <S.Container
        ref={ref}
        $maxHeight={maxHeight}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    );
  }
);

HTMLRender.displayName = "HTMLRender";

export default HTMLRender;
